module.exports = __webpack_public_path__ + "img/src/components/Receipt/question.svg?1f2b92c8";